import axios from "axios";
import APIURL from "../../Main/apiurl";

const feature_unlock_request_email = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/feature-unlock-email-config`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const upgrade_plan_request_email = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/upgrade-plan-email-config`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};
const downgrade_plan_request_email = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/downgrade-plan-email-config`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  feature_unlock_request_email,
  upgrade_plan_request_email,
  downgrade_plan_request_email
};